/* =========================================================================
   PlayShop - Effet holographique multi-couches (fiche carte + modal zoom).
     .ps-holo-card (tilt 3D) > img + .ps-holo-shine + .ps-holo-glare
   Recettes par famille via [data-holo] (CSS). Variables posées par ce JS.
   Actif PAR DÉFAUT, ?holo=0 coupe (persisté session). Écrans hover only.
   window.PSHolo.apply(mediaEl) : monte l'effet sur l'image d'un conteneur
   (data-holo lu sur mediaEl) - utilisé par le modal zoom des grilles.
   100% vanilla, license-clean (grain = SVG inline en CSS).
   ========================================================================= */
(function () {
  'use strict';

  var flag = new URLSearchParams(location.search).get('holo');
  try {
    if (flag === '0') sessionStorage.setItem('ps-holo', '0');
    else if (flag === '1') sessionStorage.removeItem('ps-holo');
  } catch (e) {}

  var disabled = false;
  try { disabled = sessionStorage.getItem('ps-holo') === '0'; } catch (e) {}
  if (disabled) return;
  if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var TILT = 12;

  // Attache tilt + pointeur lissé (ressort) à une .ps-holo-card montée.
  function wire(card) {
    var rect = null, raf = null, active = false;
    var tx = 0.5, ty = 0.5, cx = 0.5, cy = 0.5, EASE = 0.11;
    function frame() {
      cx += (tx - cx) * EASE; cy += (ty - cy) * EASE;
      var fc = Math.min(1, Math.hypot(cx - 0.5, cy - 0.5) * 2);
      var st = card.style;
      st.setProperty('--pointer-x', (cx * 100).toFixed(2) + '%');
      st.setProperty('--pointer-y', (cy * 100).toFixed(2) + '%');
      st.setProperty('--pointer-from-left', cx.toFixed(3));
      st.setProperty('--pointer-from-top', cy.toFixed(3));
      st.setProperty('--pointer-from-center', fc.toFixed(3));
      st.setProperty('--background-x', (40 + cx * 20).toFixed(2) + '%');
      st.setProperty('--background-y', (40 + cy * 20).toFixed(2) + '%');
      if (!REDUCE) {
        st.setProperty('--rotate-x', (((cx - 0.5) * 2) * TILT).toFixed(2) + 'deg');
        st.setProperty('--rotate-y', (((0.5 - cy) * 2) * TILT).toFixed(2) + 'deg');
      }
      var settled = Math.abs(tx - cx) < 0.0008 && Math.abs(ty - cy) < 0.0008;
      raf = (active || !settled) ? requestAnimationFrame(frame) : null;
    }
    function kick() { if (!raf) raf = requestAnimationFrame(frame); }
    function move(e) {
      if (!rect) rect = card.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width;
      var y = (e.clientY - rect.top) / rect.height;
      tx = x < 0 ? 0 : x > 1 ? 1 : x;
      ty = y < 0 ? 0 : y > 1 ? 1 : y;
      kick();
    }
    function enter() { rect = card.getBoundingClientRect(); active = true; card.classList.add('is-active'); kick(); }
    function leave() { active = false; card.classList.remove('is-active'); tx = 0.5; ty = 0.5; kick(); }
    card.addEventListener('pointerenter', enter);
    card.addEventListener('pointermove', move);
    card.addEventListener('pointerleave', leave);
  }

  // Monte .ps-holo-card autour de img (dans media) + couches shine/glare + câble.
  // data-holo lu sur media. On monte aussi pour 'none' (tilt + glare, sans foil).
  function buildOn(media, img) {
    if (!img || img.__psHolo) return;
    img.__psHolo = true;
    var card = document.createElement('div');
    card.className = 'ps-holo-card';
    card.setAttribute('data-holo', (media && media.getAttribute('data-holo')) || 'none');
    img.parentNode.insertBefore(card, img);
    card.appendChild(img);
    var shine = document.createElement('div'); shine.className = 'ps-holo-shine';
    var glare = document.createElement('div'); glare.className = 'ps-holo-glare';
    card.appendChild(shine);
    card.appendChild(glare);
    wire(card);
  }

  // API publique : monte l'effet sur l'image d'un conteneur (modal zoom).
  window.PSHolo = {
    apply: function (media) {
      if (!media || !document.body.classList.contains('ps-holo')) return;
      var img = media.querySelector('.ps-zoom__image') || media.querySelector('.ps-tcg__image') || media.querySelector('img');
      if (img) buildOn(media, img);
    }
  };

  // ── Fiche produit : monte l'effet sur la carte principale (si présente) ──
  var ficheDone = false;
  function buildFiche() {
    if (ficheDone) return; ficheDone = true;
    var img = document.querySelector('.ps-tcg__image');
    var media = document.querySelector('.ps-tcg__media');
    if (img && media) buildOn(media, img);
  }

  function init() {
    document.body.classList.add('ps-holo');
    var existing = document.getElementById('ps-holo-css');
    if (window.PS_HOLO_CSS && !existing) {
      var l = document.createElement('link');
      l.id = 'ps-holo-css'; l.rel = 'stylesheet'; l.href = window.PS_HOLO_CSS;
      l.addEventListener('load', buildFiche);
      l.addEventListener('error', buildFiche);
      document.head.appendChild(l);
    } else if (existing && !existing.sheet) {
      existing.addEventListener('load', buildFiche);
    } else {
      buildFiche();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
